/* Shiny Leaf — site redesign JS (header, search, drawer, cards, collection filters) */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function initHeader(h) {
    if (!h || h.dataset.slInit) return; h.dataset.slInit = 1;
    var panels = $$('[data-sl-panel]', h), triggers = $$('[data-sl-open]', h), timer;
    function closeAll(except) {
      panels.forEach(function (p) { if (p !== except) p.classList.remove('is-open'); });
      triggers.forEach(function (t) { if (!except || t.dataset.slOpen !== except.dataset.slPanel) t.setAttribute('aria-expanded', 'false'); });
    }
    function open(name) {
      var p = $('[data-sl-panel="' + name + '"]', h); if (!p) return;
      closeAll(p); p.classList.add('is-open');
      triggers.forEach(function (t) { if (t.dataset.slOpen === name) t.setAttribute('aria-expanded', 'true'); });
      if (name === 'search') { var i = $('input[type=search]', p); if (i) setTimeout(function () { i.focus(); }, 30); }
    }
    triggers.forEach(function (t) {
      var name = t.dataset.slOpen;
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var p = $('[data-sl-panel="' + name + '"]', h);
        if (p && p.classList.contains('is-open')) closeAll(); else open(name);
      });
      if (t.hasAttribute('data-sl-hover')) {
        t.addEventListener('mouseenter', function () { clearTimeout(timer); timer = setTimeout(function () { open(name); }, 90); });
        t.addEventListener('mouseleave', function () { clearTimeout(timer); });
      }
    });
    h.addEventListener('mouseleave', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { var s = $('[data-sl-panel="search"]', h); closeAll(s && s.classList.contains('is-open') ? s : null); }, 250);
    });
    h.addEventListener('mouseenter', function () { clearTimeout(timer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeDrawer(); } });
    document.addEventListener('click', function (e) { if (!h.contains(e.target)) closeAll(); });

    // drawer
    var drawer = $('[data-sl-drawer]');
    function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); document.documentElement.style.overflow = ''; } }
    $$('[data-sl-burger]', h).forEach(function (b) { b.addEventListener('click', function () { if (drawer) { drawer.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; } }); });
    if (drawer) {
      $$('[data-sl-close]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); });
      $$('.sls-acc > button', drawer).forEach(function (b) {
        b.addEventListener('click', function () { var a = b.parentNode; a.classList.toggle('is-open'); b.setAttribute('aria-expanded', a.classList.contains('is-open')); });
      });
    }

    // predictive search
    var input = $('[data-sl-q]', h), res = $('[data-sl-res]', h), lab = $('[data-sl-reslab]', h), qt;
    if (input && res) {
      var initial = res.innerHTML, initialLab = lab ? lab.textContent : '';
      input.addEventListener('input', function () {
        clearTimeout(qt);
        var q = input.value.trim();
        if (q.length < 2) { res.innerHTML = initial; if (lab) lab.textContent = initialLab; return; }
        qt = setTimeout(function () {
          fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=hide')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
              if (lab) lab.textContent = ps.length ? 'Products' : 'No products found';
              res.innerHTML = ps.map(function (p) {
                var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
                return '<a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '') +
                  '<span><strong>' + esc(p.title) + '</strong><span>' + esc(p.price ? (window.slMoney ? window.slMoney(p.price) : '$' + p.price) : '') + '</span></span></a>';
              }).join('');
            }).catch(function () {});
        }, 180);
      });
    }
  }

  function setCount(n) { $$('[data-sl-count]').forEach(function (c) { c.textContent = n; c.setAttribute('data-n', n); }); }


  /* after an item is added: refresh the cart count, then open the Qikify slide-in cart (with its upsells);
     if that app isn't there, go to the cart page */
  function afterAdd(btn, label) {
    function done() { if (btn) { btn.disabled = false; if (label != null) btn.textContent = label; } }
    function goCart() { window.location.href = window.slCartUrl || (root + 'cart'); }
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
    if (typeof window.STICKY_CART_UPDATE === 'function' && typeof window.STICKY_CART_OPEN === 'function') {
      Promise.resolve().then(function () { return window.STICKY_CART_UPDATE(); })
        .then(function () { window.STICKY_CART_OPEN(); done(); })
        .catch(goCart);
    } else goCart();
  }
  window.slAfterAdd = afterAdd;

  // product cards: add to cart (one-time purchase — no selling plan)
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-sl-add]'); if (!f) return;
    e.preventDefault();
    var b = $('button', f), id = f.querySelector('[name=id]').value, txt = b.textContent;
    b.disabled = true; b.textContent = 'Adding…';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { afterAdd(b, txt); })
      .catch(function () { b.disabled = false; b.textContent = txt; f.submit(); });
  });

  // collection chips (client-side filter over the loaded grid)
  function initFilters(sec) {
    if (sec.dataset.slInit) return; sec.dataset.slInit = 1;
    var btns = $$('[data-sl-filter]', sec), cards = $$('[data-sl-cat]', sec), count = $('[data-sl-n]', sec);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.dataset.slFilter, n = 0;
        btns.forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
        cards.forEach(function (c) { var show = f === 'all' || (' ' + c.dataset.slCat + ' ').indexOf(' ' + f + ' ') > -1; c.hidden = !show; if (show) n++; });
        if (count) count.textContent = n + (n === 1 ? ' product' : ' products');
      });
    });
    var sort = $('[data-sl-sort]', sec);
    if (sort) sort.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); window.location.href = u.toString(); });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!a) return;
    if (typeof window.STICKY_CART_OPEN === 'function') { e.preventDefault(); window.STICKY_CART_OPEN(); }
    else if (window.slCartUrl) { e.preventDefault(); window.location.href = window.slCartUrl; }
  });

  function init() {
    $$('[data-sl-header]').forEach(initHeader);
    $$('[data-sl-cgrid]').forEach(initFilters);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.slSetCartCount = setCount;
})();
/* inner pages: quiz + ingredient filter */
(function () {
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function initQuiz(root) {
    if (root.dataset.slInit) return; root.dataset.slInit = 1;
    var qs = $$('[data-sl-q]', root), results = $$('[data-sl-result]', root), ans = {}, cur = 0;
    function visible() {
      return qs.filter(function (q) {
        var c = q.getAttribute('data-show-if'); if (!c) return true;
        var p = c.split('='), vals = (p[1] || '').split(',');
        return vals.indexOf(ans[p[0]]) > -1;
      });
    }
    function show() {
      var v = visible();
      qs.forEach(function (q) { q.hidden = true; });
      results.forEach(function (r) { r.hidden = true; });
      if (cur < v.length) {
        var q = v[cur]; q.hidden = false;
        var n = q.querySelector('[data-sl-qn]'); if (n) n.textContent = 'Question ' + (cur + 1);
        var bar = q.querySelector('.sls-qz__bar i'); if (bar) bar.style.width = Math.round((cur + 1) / v.length * 100) + '%';
        var back = q.querySelector('[data-sl-back]'); if (back) back.hidden = cur === 0;
        var next = q.querySelector('[data-sl-next]'); if (next) next.disabled = !ans[q.dataset.slQ];
      } else {
        var key = ['q1', 'q2', 'q3'].map(function (k) { return ans[k] || '-'; });
        var hit = results.filter(function (r) {
          var p = r.getAttribute('data-sl-result').split('|');
          return p.every(function (x, i) { return x === '*' || x === key[i]; });
        })[0];
        if (hit) { hit.hidden = false; hit.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    }
    qs.forEach(function (q) {
      $$('.sls-qz__o', q).forEach(function (o) {
        o.addEventListener('click', function () {
          $$('.sls-qz__o', q).forEach(function (x) { x.setAttribute('aria-pressed', x === o); });
          ans[q.dataset.slQ] = o.dataset.v;
          var next = q.querySelector('[data-sl-next]'); if (next) next.disabled = false;
        });
      });
      var nx = q.querySelector('[data-sl-next]'); if (nx) nx.addEventListener('click', function () { cur++; show(); });
      var bk = q.querySelector('[data-sl-back]'); if (bk) bk.addEventListener('click', function () { cur = Math.max(0, cur - 1); show(); });
    });
    $$('[data-sl-restart]', root).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); ans = {}; cur = 0; $$('.sls-qz__o', root).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); show(); root.scrollIntoView({ behavior: 'smooth' }); }); });
    show();
  }
  function initIng(root) {
    if (root.dataset.slInit) return; root.dataset.slInit = 1;
    var cards = $$('.sls-ing', root), tab = 'all', letter = '';
    function apply() { cards.forEach(function (c) { var okT = tab === 'all' || c.dataset.w === tab || c.dataset.w === 'both'; var okL = !letter || c.dataset.l === letter; c.hidden = !(okT && okL); }); }
    $$('[data-sl-filter]', root).forEach(function (b) { b.addEventListener('click', function () { tab = b.dataset.slFilter; $$('[data-sl-filter]', root).forEach(function (x) { x.classList.toggle('is-on', x === b); }); apply(); }); });
    $$('[data-sl-letter]', root).forEach(function (b) { b.addEventListener('click', function () { letter = letter === b.dataset.slLetter ? '' : b.dataset.slLetter; $$('[data-sl-letter]', root).forEach(function (x) { x.classList.toggle('is-on', x.dataset.slLetter === letter); }); apply(); }); });
  }
  function init() { $$('[data-sl-quiz]').forEach(initQuiz); $$('[data-sl-ing]').forEach(initIng); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
/* Touch fix for chat widgets (Shopify Inbox etc.) */
(function () {
  document.documentElement.addEventListener('touchend', function (e) {
    var t = e.target;
    if (t && t.shadowRoot && t.tagName && t.tagName.indexOf('-') > -1) e.stopPropagation();
  });
})();